/**
 * Authenticated app chrome: a premium left sidebar (brand · nav · account) + the page outlet.
 */
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/store';

export function AppLayout(): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = (): void => {
    logout();
    navigate('/login', { replace: true });
  };

  const navClass = ({ isActive }: { isActive: boolean }): string => (isActive ? 'active' : '');
  const initial = (user?.email ?? '?').charAt(0).toUpperCase();

  return (
    <div className="shell">
      <aside className="sidebar">
        <Link to="/apps" className="sidebar-brand">
          <span className="brand-mark">A</span>
          App&nbsp;Builder
        </Link>

        <div className="sidebar-section">Deployment console</div>
        <nav className="sidebar-nav">
          <NavLink to="/apps" className={navClass}>
            <span className="nav-ico" aria-hidden>📱</span>
            Apps
          </NavLink>
          <NavLink to="/account" className={navClass}>
            <span className="nav-ico" aria-hidden>⚙️</span>
            Account
          </NavLink>
        </nav>

        <div className="sidebar-foot">
          <div className="sidebar-user">
            <span className="avatar">{initial}</span>
            <span className="sidebar-user-email">{user?.email}</span>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="main-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
